import { reactWrapperRoute } from '@ami/angular/core/react-interop';
import { CustomerInventoryV1Component } from './customer-inventory-v1/customer-inventory-v1.component';
import { Route } from '@angular/router';

export const v1Routes: Route[] = [
  reactWrapperRoute(CustomerInventoryV1Component)
];
